import { Component, OnInit, ViewChild, HostListener, } from '@angular/core';
import { } from 'googlemaps';

var map;

@Component({
  selector: 'app-wedding-info',
  templateUrl: './wedding-info.component.html',
  styleUrls: ['./wedding-info.component.scss']
})
export class WeddingInfoComponent implements OnInit {

  @ViewChild('gmap') gmapElement: any;
  map: google.maps.Map;
  screenWidth: any;
  resizedWidth = false; 

  constructor() { 
    this.getScreenSize();
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
      this.screenWidth = window.innerWidth;
      console.log(this.screenWidth);
      if(this.screenWidth > 1199){
        this.resizedWidth = true;
      }
  }

  ngOnInit(){}
  
  ngAfterViewChecked() {
    if(this.resizedWidth) {
      this.getGoogleMaps(); 
      this.resizedWidth = false; 
    }
  }

  ngAfterViewInit(){
    this.getGoogleMaps();
  }

  getGoogleMaps() {

    var mapProp = {
      center: new google.maps.LatLng(35.735480, -78.783771),
      zoom: 14,
      mapTypeId: google.maps.MapTypeId.ROADMAP
    };
    map = new google.maps.Map(this.gmapElement.nativeElement, mapProp);

    var contentString = '<div id="content">'+
    '<div id="siteNotice">'+
    '</div>'+
    '<h6 id="firstHeading" class="firstHeading">La Quinta Inn & Suites by Wyndham</h6>'+
    '<div id="bodyContent">'+
    '<p>191 Crescent Commons <br>'+
    'Cary, NC 27518</p>'+
    '<p><a href="https://www.google.com/maps/place/La+Quinta+Inn+%26+Suites+by+Wyndham+Raleigh+Cary/@35.7356621,-78.7837597,18.98z/data=!4m8!3m7!1s0x89ac8cd2e2121bd7:0x1a92b4bd09245ea7!5m2!4m1!1i2!8m2!3d35.7354441!4d-78.7836942" target="blank">'+
    'View on Google Maps</a> </p>'+
    '</div>'+
    '</div>';

    var infowindow = new google.maps.InfoWindow({
      content: contentString,
      maxWidth: 200
    });

    var marker = new google.maps.Marker({
      position: {lat: 35.735480, lng: -78.783771 },
      map: map,
      title: 'La Quinta Inn & Suites By Wyndham'
    });

    marker.addListener('click', function() {
      infowindow.open(map, marker);
    });
  }
  
  onNavigate(){
    window.open("https://www.macgregordowns.org", "_blank");
  }

  onLaQuinta(){
    window.open("https://www.wyndhamhotels.com/laquinta/cary-north-carolina/la-quinta-raleigh-cary/overview?CID=LC:LQ::GGL:RIO:National:53028&iata=00093796", "_blank");
  }

  onMichele(){
    window.open("https://www.idoweddingsbymichele.com/");
  }
}
